import {currentMinuteBucket} from '@/lib/date-utils'

const AUTH_BOUNCE_KEY = 'iam.authBounceCount'

export const AUTH_BOUNCE_THRESHOLD = 2

interface BounceState {
    minute: string
    count: number
}

function currentMinute(): string {
    return currentMinuteBucket()
}

function readBounceState(): BounceState {
    const raw = sessionStorage.getItem(AUTH_BOUNCE_KEY)
    if (!raw) return {minute: currentMinute(), count: 0}
    try {
        const parsed = JSON.parse(raw) as BounceState
        if (parsed.minute !== currentMinute()) return {minute: currentMinute(), count: 0}
        return parsed
    } catch (e) {
        void e // session-storage payload corrupt — reset counter to current minute
        return {minute: currentMinute(), count: 0}
    }
}

export function incrementBounceCount(): number {
    const state = readBounceState()
    const next: BounceState = {minute: state.minute, count: state.count + 1}
    sessionStorage.setItem(AUTH_BOUNCE_KEY, JSON.stringify(next))
    return next.count
}

export function clearBounceCount(): void {
    sessionStorage.removeItem(AUTH_BOUNCE_KEY)
}

type LoopDetectedCallback = () => void
let loopDetectedCallback: LoopDetectedCallback | null = null

export function onAuthLoopDetected(callback: LoopDetectedCallback): () => void {
    loopDetectedCallback = callback
    return () => {
        if (loopDetectedCallback === callback) {
            loopDetectedCallback = null
        }
    }
}

export function notifyAuthLoopDetected(): void {
    loopDetectedCallback?.()
}
